import BlockContent from './component';

export default BlockContent;
